<template>
  <div class="maininfo">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in articles" :key="item.id">
          <router-link :to="`/news/info/${item.plateid}/${item.uuid}`">
            <img :src="`${IP_TEST}/uploads/${item.picsrc}`" width="800" height="430" alt="" />
          </router-link>
        </div>
      </div>
    </div>
    <ul class="newslist">
      <router-link class="item" v-for="(item,index) in newsArr" :key="index" :to="`/news/info/${item.plateid}/${item.uuid}`" tag="li">
        <div class="newstitle">
          <h3 v-text="item.keywords" :class="index == isActive &&'selecthot'"></h3>
          <span :class="index == isActive &&'selecthot'">{{item.addtime | datefilter}}</span>
        </div>
        <p class="newsinfo" :class="index == isActive &&'selecthot'" v-text="item.description"></p>
        <div v-if="item.top == '1'" class="hot">
          <span>头条</span>
        </div>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { getArticles, getPicNews } from '@/request/get'
import { IP_TEST, NEWS_HOT } from '@/config'
export default {
  name: "NewsHot",
  data() {
    return {
      timeoutid:'',
      activeIndex: 4,
      newsArr: [],
      articles: [],
      IP_TEST: IP_TEST
    }
  },
  computed: {
    isActive() {
      // console.log(this.activeIndex);
      return this.activeIndex == 4 ? 0 : this.activeIndex - 1;
    }
  },
  created() {
    this.getPicNews();
    this.getArticles();
  },
  mounted() {
  },
  filters: {
    datefilter(value) {
      // console.log(value);
      return value.slice(5,-8);
    }
  },
  methods: {
    _sortByTop(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].top == "1") {
          arr.unshift(arr[i]);
          arr.splice(i + 1, 1);
          break;
        }
      }
      return arr;
    },
    createSwiper() {
      // eslint-disable-next-line no-undef
      new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        autoplay: 5000,
        speed: 500,
        grabCursor: true,
        onSlideChangeStart: swiper => this.activeIndex = swiper.activeIndex 
        // 如果需要分页器
        // pagination: '.swiper-pagination',
        // // 如果需要前进后退按钮
        // nextButton: '.swiper-button-next',
        // prevButton: '.swiper-button-prev',
        // // 如果需要滚动条
        // scrollbar: '.swiper-scrollbar',
      })        
    },
    async getPicNews() {
      let result = await getPicNews();
      result = result.data;
      this.articles = result && this._sortByTop(result);
      this.$nextTick(() => this.createSwiper());
    },
    async getArticles() {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => NEWS_HOT.includes(item.name));
      let result = await getArticles(list[0].uuid);
      result = result.data;
      this.newsArr = result && this._sortByTop(result);
    }
  }
};
</script>
<style scoped>
.maininfo{
  position: relative;
  margin: 13px 0 26px;
  display: flex;
  justify-content: start;
}
.maininfo>.newslist{
  position: relative;
  width: 386px;
  height: 430px;
  overflow: hidden;
}

.maininfo>.newslist>.item{
  position: relative;
  padding: 18px 14px;
  width: 358px;
  height: 66px;
  background-color: #FFFFFF;
  margin-bottom: 7px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: PingFang SC;
}
.maininfo>.newslist>.item>.hot{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 60px;
  height: 40px;
  background: url(/static/img/toutiao.png) no-repeat bottom right;
}
.maininfo>.newslist>.item>.hot>span {
  position: absolute;
  top: 14px;
  left: 29px;
  width: 30px;
  height: 24px;
  font-size: 15px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 22px;
  transform: rotate(-30deg);
}
.maininfo>.newslist>.item>.newsinfo {
  width: 344px;
  height: 36px;
  font-size: 13px;
  font-weight: 500;
  color: #666666;
  letter-spacing:1px;
  line-height: 20px;
  overflow: hidden;
}
.maininfo>.newslist>.item>.newstitle{
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}
.maininfo>.newslist>.item>.newstitle>h3 {
  width: 244px;
  height: 16px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 16px;
  overflow: hidden;
  }
  
  .maininfo>.newslist>.item>.newstitle>span {
    padding-right: 18px;
    width: 47px;
    height: 11px;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    line-height: 11px;
    overflow: hidden;
  }
    .maininfo>.swiper {
      position: relative;
      width: 800px;
      height: 430px;
      margin-right: 12px;
      overflow: hidden;
      z-index: 1;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      width: 800px;
      line-height: 430px;
    }
</style>

